/* eslint-disable camelcase */
import React, { Component } from 'react';
import { connect } from 'dva';
import { Tabs, Form, Input, Button, Spin } from 'antd';
import DeptSelect from './components/deptSelect'
import RoleSelect from './components/groupSelect';
import WxEditor from '@/components/WxEditor';
import styles from './setting.less';

let wwei_editor = null;

@connect(({ baseSetting }) => ({
  ...baseSetting,
}))


class BaseSetting extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch({
      type: 'baseSetting/fetchDetails',
      callback: () => {
        const { supervisePublicity } = this.props;
        wwei_editor = window.UE.getEditor("wwei_editor");
        wwei_editor.ready(() => {
          wwei_editor.setContent(supervisePublicity);
        });
      }
    });
  }

  tabsChange = key => {
    console.log(key);
  }

  handleSubmit = e => {
    const { id, dispatch, deptSelectTreeNode, groupSelectTreeNode } = this.props;
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        let dutyAreaList = [];
        groupSelectTreeNode.map(item => {
          dutyAreaList.push({
            id: item.value,
            name: item.label
          })
        })
        let talentsStoreroomList = [];
        deptSelectTreeNode.map(item => {
          talentsStoreroomList.push({
            deptId: item.value,
            deptName: item.label
          })
        })
        dispatch({
          type: 'baseSetting/saveOrUpdate',
          params: {
            id,
            supervisePublicity: wwei_editor.getContent(),
            dutyAreaList,
            talentsStoreroomList
          },
          callback: () => {
            dispatch({
              type: 'baseSetting/fetchDetails',
              callback: () => {
                const { supervisePublicity } = this.props;
                wwei_editor = window.UE.getEditor("wwei_editor");
                wwei_editor.ready(() => {
                  wwei_editor.setContent(supervisePublicity);
                });
              }
            });
          }
        })
      }
    });
  };

  render() {
    const { supervisePublicity, spinProps } = this.props;
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: { span: 2 },
      wrapperCol: { span: 18 },
    };

    const formItemLayoutWithOutLabel = {
      wrapperCol: { span: 2, offset: 19 },
    };

    return (
      <Spin {...spinProps}>
        <Form
          {...formItemLayout}
          name="basic"
          onSubmit={this.handleSubmit}
        >
          <Form.Item label="督导公示" className="content">
            {getFieldDecorator('supervisePublicity', {
              initialValue: supervisePublicity,
            })(<WxEditor showTemplate={false} />)}
          </Form.Item>
          <Form.Item
            label='人才库设置'
          >
            <DeptSelect />
          </Form.Item>
          <Form.Item
            label='责任区设置'
          >
            <RoleSelect />
          </Form.Item>
          <Form.Item {...formItemLayoutWithOutLabel} >
            <Button type="primary" htmlType="submit">
              保存
            </Button>
          </Form.Item>
        </Form>
      </Spin>
    )
  }
}

export default Form.create()(BaseSetting);
